import React, { Component } from "react";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import moment from "moment";
import _ from "i18n";
import { selectLoggedAs } from "Selectors";
import {
  PERIOD_UNIT,
  CLIENT_CRM_TYPE_FILTER,
  CLIENT_GROUP_CRM_FILTER,
  DELETED_STATUS
} from "Config";
import {
  initFilterClient,
  setFilterClientGroup,
  setFilterClient,
  setFilterCollaborators,
  setFilterTaskCategory,
  setFilterPeriodUnit,
  setTimeSheetSearchWord,
  setClientsDeletedStatus,
  setClientCRMGroup,
  setClientCRMType,
  setFilterPeriods,
  setPartner
} from "actions";
import {
  fetchTaskCategorySuggestions,
  fetchClientGroupSuggestions,
  fetchClientSuggestions,
  fetchCollaboratorSuggestions,
  fetchTimeSheet,
  fetchUsers
} from "thunks";
import {
  renderPeriodsByRangeDateAndPeriodUnit,
  renderTeamYears,
  parsePreference,
  viewDataBy
} from "Utils";
import styles from "../TimeSheet/TimeSheet.local.scss";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";

class TimeSheetFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().startOf("year"),
      endDate: moment(),
      yearDivIsVisible: false,
      disabledYearDiv: false,
      year: moment().year(),
      periodUnit: PERIOD_UNIT.YEAR,
      selectedKey: 0,
      collaboratorOptions: []
    };

    this.loadClientGroupSuggestions = debounce(
      this.loadClientGroupSuggestions,
      1000
    );
    this.loadClientSuggestions = debounce(this.loadClientSuggestions, 1000);
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);
  }

  componentDidMount() {
    const { user, dispatch, preferences } = this.props;
    dispatch(fetchUsers());
    dispatch(
      setPartner(
        parsePreference(preferences.prestations).allowViewDataBy === 11
          ? Number(user.id)
          : null
      )
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partner !== this.props.partner) {
      this.setState({ selectedKey: this.state.selectedKey + 1 });
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }
  handleSearchInputChange(word) {
    this.props.dispatch(setTimeSheetSearchWord(word));
    this.handleRefreshTimeSheetTree();
  }
  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleRefreshTimeSheetTree = () => {
    this.props.dispatch(fetchTimeSheet());
  };

  handlePartnerChange = selected => {
    this.setState(() => {
      this.props.dispatch(setPartner(Number(selected)));
      this.handleRefreshTimeSheetTree();
    });
  };

  handlePeriodUnitChange = selected => {
    this.setState({ periodUnit: selected });
    this.props.dispatch(setFilterPeriodUnit(selected));
    this.props.dispatch(
      setFilterPeriods(
        renderPeriodsByRangeDateAndPeriodUnit(
          this.state.startDate,
          this.state.endDate,
          selected
        )
      )
    );
    this.handleRefreshTimeSheetTree();
  };

  handleClientGroupChange = selected => {
    let groups = selected.map(element => element.value);
    this.props.dispatch(setFilterClientGroup(groups));
    this.props.dispatch(initFilterClient());
    this.handleRefreshTimeSheetTree();
  };

  handleClientChange = selected => {
    // let clients = selected.map(element => element.value);
    this.props.dispatch(setFilterClient(selected));
    this.handleRefreshTimeSheetTree();
  };

  handleCollaboratorChange = selected => {
    // let collaborators = selected.map(element => element.value);
    const actifs = this.state.collaboratorOptions.filter(item => item.isActif);

    const combined = [...actifs, ...selected];
    const uniqueSelection = Array.from(
      new Map(combined.map(item => [item.value, item])).values()
    );

    this.props.dispatch(setFilterCollaborators(uniqueSelection));
    this.handleRefreshTimeSheetTree();
  };

  handleTaskCategoryChange = selected => {
    let types = selected.map(element => element.value);
    this.props.dispatch(setFilterTaskCategory(types));
    this.handleRefreshTimeSheetTree();
  };

  handleSetDeletedStatus = selectedStatus => {
    const { dispatch } = this.props;
    dispatch(setClientsDeletedStatus(selectedStatus));
    this.handleRefreshTimeSheetTree();
  };

  handleGroupCRMClientChange = selected => {
    const { dispatch } = this.props;
    dispatch(setClientCRMGroup(selected));
    this.handleRefreshTimeSheetTree();
  };

  handleTypeCRMClientChange = selected => {
    const { dispatch } = this.props;
    dispatch(setClientCRMType(selected));
    this.handleRefreshTimeSheetTree();
  };

  handleRangeDateChange = ({ startDate, endDate }) => {
    let { selected } = this.props.timeSheetFilter.periodUnit;

    let start =
      endDate === null && startDate
        ? startDate.isAfter(this.state.endDate)
          ? this.state.endDate
          : startDate
        : startDate === null
          ? this.state.startDate
          : startDate;

    let end =
      endDate === null
        ? startDate.isAfter(this.state.endDate)
          ? startDate
          : this.state.endDate
        : endDate;
    let differentYear = start.year() !== end.year();
    this.setState(
      {
        startDate: start,
        endDate: end,
        year: differentYear ? this.state.year : end.year(),
        disabledYearDiv: differentYear
      },
      () => {
        this.props.dispatch(
          setFilterPeriods(
            renderPeriodsByRangeDateAndPeriodUnit(
              this.state.startDate,
              this.state.endDate,
              selected
            )
          )
        );
        this.handleRefreshTimeSheetTree();
      }
    );
  };

  loadClientGroupSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClientGroupSuggestions(searchWord))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return { value: t.group, label: t.group, color: "#000000" };
        });
        callback(categories);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadClientSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClientSuggestions(searchWord))
      .then(res => {
        let clientsList = res.value.data.data.filter(item => item !== null);
        const clients = clientsList.map(t => {
          return { value: t.id, label: t.name, color: "#000000" };
        });
        callback(clients);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadTaskCategorySuggestions = lng => (searchWord, callback) => {
    this.props
      .dispatch(fetchTaskCategorySuggestions(searchWord))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return { value: t.id, label: t.label[lng], color: "#000000" };
        });
        callback(categories);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    const { preferences, collaborator, partner } = this.props;
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const data = res.value.data.data;
        const list = viewDataBy(preferences.prestations, data, collaborator);
        const collaborators = list.filter(item => item !== null).map(t => {
          return {
            value: t.id,
            label: t.name,
            partner: t.partner.value,
            isActif: t.isActif,
            color: "#000000"
          };
        });
        const options = partner
          ? collaborators.filter(c => c.partner === partner)
          : collaborators;
        this.setState({
          collaboratorOptions: options
        });
        callback(options);
      })
      .catch(er => {
        this.setState({
          collaboratorOptions: []
        });
        callback([]);
      });
  };

  renderYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{
          background: this.state.disabledYearDiv ? "#f1f2f4" : "#6d7f92",
          color: this.state.disabledYearDiv ? "#8d8d8d" : "#ffffff"
        }}
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={"icon icon-arrow-down"}
                  style={{
                    color: this.state.disabledYearDiv ? "#8d8d8d" : "#ffffff"
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {renderTeamYears().map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    this.setState({
      startDate: new moment(year + "-01-01"),
      endDate:
        moment().year() === year ? new moment() : new moment(year + "-12-31"),
      disabledYearDiv: false
    });
    this.props.dispatch(
      setFilterPeriods(
        renderPeriodsByRangeDateAndPeriodUnit(
          new moment(year + "-01-01"),
          moment().year() === year ? new moment() : new moment(year + "-12-31"),
          this.state.periodUnit
        )
      )
    );
    dispatch(fetchTimeSheet());
  };

  render() {
    let {
      timeSheetFilter,
      listFilters,
      filter,
      customAddOn,
      lng,
      nbResult,
      label,
      marginLeft,
      partner,
      partners,
      loggedAs,
      preferences,
      collaborator
    } = this.props;

    let partnerOptions =
      partners &&
      partners.map(p => {
        return {
          label: p.name,
          value: p.id,
          zone: p.zone
        };
      });

    let filters = [
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          key: this.state.selectedKey,
          value: timeSheetFilter.collaborator.selected,
          placeholder: _("collaborator"),
          handleChange: this.handleCollaboratorChange,
          loadSuggestions: this.loadCollaboratorSuggestions,
          values: timeSheetFilter.collaborator
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          placeholder: _("clientGroup"),
          handleChange: this.handleClientGroupChange,
          loadSuggestions: this.loadClientGroupSuggestions,
          values: timeSheetFilter.clientGroup.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: timeSheetFilter.client.selected,
          key: timeSheetFilter.clientGroup.selected.length,
          placeholder: _("client"),
          handleChange: this.handleClientChange,
          loadSuggestions: this.loadClientSuggestions,
          values: timeSheetFilter.client.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          placeholder: _("taskCategory"),
          handleChange: this.handleTaskCategoryChange,
          loadSuggestions: this.loadTaskCategorySuggestions(lng),
          values: timeSheetFilter.TaskCategory
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          values: filter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: filter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("notClient"),
          options: DELETED_STATUS,
          values: listFilters.entityClientId.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("periodeType"),
          options: [
            { value: PERIOD_UNIT.YEAR, label: _(PERIOD_UNIT.YEAR) },
            { value: PERIOD_UNIT.SEMESTER, label: _(PERIOD_UNIT.SEMESTER) },
            { value: PERIOD_UNIT.QUARTER, label: _(PERIOD_UNIT.QUARTER) },
            { value: PERIOD_UNIT.MONTH, label: _(PERIOD_UNIT.MONTH) },
            { value: PERIOD_UNIT.DATE, label: _(PERIOD_UNIT.DATE) }
          ],
          action: this.handlePeriodUnitChange,
          values: timeSheetFilter.periodUnit.selected
        }
      },
      {
        grid: 6,
        type: "RANGE_DATE_PICKER",
        options: {
          placeholder: _("datePeriod"),
          dateRange: {
            startDate: this.state.startDate,
            endDate: this.state.endDate
          },
          creationDate: moment("20190314", "YYYYMMDD"),
          action: this.handleRangeDateChange
        }
      },
      {
        grid: 3,
        type: "SPACE",
        options: {}
      }
    ];

    if (
      [1, 11].includes(parsePreference(preferences.prestations).allowViewDataBy)
    ) {
      filters.unshift({
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          isSearch: true,
          isDisabled:
            parsePreference(preferences.prestations).allowViewDataBy === 11,
          placeholder: _("partner"),
          options: partnerOptions,
          values:
            loggedAs === "COLLABORATOR" &&
            parsePreference(preferences.prestations).allowViewDataBy === 11
              ? collaborator.partner.value
              : partner,
          action: this.handlePartnerChange
        }
      });
    }
    return (
      <div className="row align-center medium-12">
        <div className={`medium-12 ${styles.filter_bar}`}>
          {this.renderYearSelect()}
          <TTPFilterHorizontalBar
            button
            filters={filters}
            customAddOn={customAddOn}
            searchInputValue={timeSheetFilter.searchWord.searchWord}
            searchPlaceholder="Search by client name"
            handleResetFilter={this.handleResetFilter}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
            nbResult={nbResult}
            label={label}
            marginLeft={marginLeft}
            language={lng}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  timeSheetFilter: state.timeSheetTree.filter,
  filter: state.financialSheet.periodTree.filter,
  listFilters: state.clients.filter,
  lng: state.params.lng,
  user: state.auth.user,
  partner: state.auth.partner,
  partners: state.auth.partnerOptions,
  currentOrganization: state.auth.currentOrganization,
  users: state.authorizations.items,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth.spaceAs
});

export default connect(mapStateToProps)(TimeSheetFilter);



// WEBPACK FOOTER //
// ./src/components/TimeSheetFilter/TimeSheetFilter.js